module.exports = __webpack_public_path__ + "static/media/chef_house_bg_1280x800.27af554d.jpg";